const navbar = {
  logOut: "Log Out",
  dashboard: "หน้าแรก",
  screenfull: "Screenfull",
  task: "ตรวจสอบคำสั่งซื้อ",
  theme: "ธีม",
  size: "Global Size"
} 
export default navbar